var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('system',{staticClass:"system system--lock"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }